import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './Layout.css';

const NAV = [
  { to: '/',            icon: '⊞', label: 'Dashboard',    end: true },
  { to: '/orders',      icon: '📦', label: 'Orders' },
  { to: '/drivers',     icon: '🏍️', label: 'Drivers' },
  { to: '/stores',      icon: '🏪', label: 'Stores' },
  { to: '/analytics',   icon: '📊', label: 'Analytics' },
  { to: '/leads',       icon: '📋', label: 'Demo Leads' },
  { to: '/testimonials',icon: '⭐', label: 'Testimonials' },
  { to: '/users',       icon: '👤', label: 'Users',        admin: true },
  { to: '/settings',    icon: '⚙️', label: 'Settings' },
];

export default function Layout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => { logout(); navigate('/login'); };

  return (
    <div className="layout">
      <aside className="sidebar">
        <div className="sidebar__logo">
          <svg viewBox="0 0 180 44" fill="none" xmlns="http://www.w3.org/2000/svg" height="32">
            <defs>
              <linearGradient id="lg" x1="0" y1="0" x2="1" y2="1">
                <stop offset="0%" stopColor="#00D4FF"/>
                <stop offset="100%" stopColor="#0057FF"/>
              </linearGradient>
            </defs>
            <polygon points="0,40 11,4 23,4 12,40" fill="url(#lg)"/>
            <polygon points="26,40 37,4 47,4 36,40" fill="url(#lg)" opacity="0.75"/>
            <text x="56" y="31" fontFamily="Inter,sans-serif" fontSize="14" fontWeight="800" fill="#fff" letterSpacing="1">ROUTE ROVER</text>
          </svg>
        </div>

        <nav className="sidebar__nav">
          {NAV.filter(n => !n.admin || ['superadmin','admin'].includes(user?.role)).map(n => (
            <NavLink key={n.to} to={n.to} end={n.end}
              className={({ isActive }) => `sidebar__link${isActive ? ' sidebar__link--active' : ''}`}>
              <span className="sidebar__icon">{n.icon}</span>
              {n.label}
            </NavLink>
          ))}
        </nav>

        <div className="sidebar__user">
          <div className="sidebar__avatar">{user?.name?.charAt(0) || 'A'}</div>
          <div className="sidebar__info">
            <strong>{user?.name}</strong>
            <span>{user?.role}</span>
          </div>
          <button className="sidebar__logout" onClick={handleLogout} title="Logout">↩</button>
        </div>
      </aside>

      <main className="main-content">
        <Outlet />
      </main>
    </div>
  );
}
